import {
  dateFromUnixTimestamp as V,
  rehydrateDateAfterJsonization as Y,
} from "../../util/date-utils.js";
import { logger as E } from "../../../shared-lib/index.js";
import fi from "./trigger-condition.js";
import { validateValueIsFromEnum as ta } from "../../util/code-utils.js";
export default class pt {
  constructor(t, i = [], s, e, r = 0, h, l, o = 0, n = pt.Td, a, u, d) {
    (this.id = t),
      (this.Pd = i),
      (this.startTime = s),
      (this.endTime = e),
      (this.priority = r),
      (this.type = h),
      (this.data = l),
      (this.Ed = o),
      (this.Nd = n),
      (this.Vn = a),
      (this._d = u),
      (this.Id = d),
      (this.id = t),
      (this.Pd = i || []),
      void 0 === s && (s = null),
      (this.startTime = s),
      void 0 === e && (e = null),
      (this.endTime = e),
      (this.priority = r || 0),
      (this.type = h),
      (this.Ed = o || 0),
      null == a && (a = 1e3 * (this.Ed + 30)),
      (this.Vn = a),
      (this.data = l),
      null != n && (this.Nd = n),
      (this._d = u),
      (this.Id = d || null);
  }
  xd(t) {
    return (
      null == this.Id || (this.Nd !== pt.Td && t - this.Id >= 1e3 * this.Nd)
    );
  }
  zd(t) {
    this.Id = t;
  }
  Md(t) {
    const i = t + 1e3 * this.Ed;
    return Math.max(i - new Date().valueOf(), 0);
  }
  Bd(t) {
    const i = new Date().valueOf() - t,
      s = null == t || isNaN(i) || null == this.Vn || i < this.Vn;
    return (
      s ||
        E.info(
          `Trigger action ${this.type} is no longer eligible for display - fired ${i}ms ago and has a timeout of ${this.Vn}ms.`,
        ),
      !s
    );
  }
  static fromJson(t) {
    const i = t.id,
      s = [];
    for (let i = 0; i < t.trigger_condition.length; i++)
      s.push(fi.fromJson(t.trigger_condition[i]));
    const e = V(t.start_time),
      r = V(t.end_time),
      h = t.priority,
      l = t.type,
      o = t.delay,
      n = t.re_eligibility,
      a = t.timeout,
      u = t.data,
      d = t.min_seconds_since_last_trigger;
    return ta(
      pt.Ln,
      l,
      "Could not construct Trigger from server data",
      "Trigger.Types",
    )
      ? new pt(i, s, e, r, h, l, u, o, n, a, d)
      : null;
  }
  gt() {
    const t = [];
    for (let i = 0; i < this.Pd.length; i++) t.push(this.Pd[i].gt());
    return {
      i: this.id,
      c: t,
      s: this.startTime,
      e: this.endTime,
      p: this.priority,
      t: this.type,
      da: this.data,
      d: this.Ed,
      r: this.Nd,
      tm: this.Vn,
      ss: this._d,
      ld: this.Id,
    };
  }
  static _u(t) {
    const i = [],
      s = t.c || [];
    for (let t = 0; t < s.length; t++) i.push(fi._u(s[t]));
    return new pt(
      t.i,
      i,
      Y(t.s),
      Y(t.e),
      t.p,
      t.t,
      t.da,
      t.d,
      t.r,
      t.tm,
      t.ss,
      t.ld,
    );
  }
}
(pt.Ln = { Kn: "inapp", Cd: "templated_iam" }), (pt.Td = -1);
